import React from 'react';
import { Add, TouchAppOutlined, MemoryOutlined, LocalOfferOutlined } from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import './Dashboard.css';
import Background from '../../common/Background';
import Cardimg1 from "../../../assets/img/illustrations/corner-1.png";
import Cardimg2 from "../../../assets/img/illustrations/corner-4.png";


const QuickLinksCards = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  
  const loginStatus = {
    activeTradeSubscription: user?.activeTradeSubscription || false,
    brokerLoggedIn: user?.brokerLoggedIn || false,
    accounts: user?.accounts ?? 0,
    brokerList: user?.brokerList || []
  };

  const quickLinks = [
    {
      title: "Add Broker",
      description: "Connect your trading account",
      icon: Add,
      gradient: "from-blue-500-to-cyan-500",
      link: "/broker-login",
    },
    {
      title: "Terminal",
      description: "Manual trading interface",
      icon: TouchAppOutlined,
      gradient: "from-green-500-to-emerald-500",
      link: "/terminal",
    },
    {
      title: "Algo signals",
      description: "Algorithmic trading platform",
      icon: MemoryOutlined,
      gradient: "from-purple-500-to-violet-500",
      link: "/algo/accounts",
    },
    {
      title: "Pricing",
      description: "View our pricing plans",
      icon: LocalOfferOutlined,
      gradient: "from-orange-500-to-red-500",
      link: "/pricing",
    }
  ];

  return (
    <Background image={Cardimg2} className="bg-card">
      <div className="section-header">
        <h2 className="section-title">Quick Links</h2>
        <span className="section-subtitle">
          Here are some quick links for you to start
        </span>
      </div>
      <div className="quick-links-grid">
        {quickLinks.map((item, index) => {   
          return (
            <Link key={index} to={item.link} className={`quick-link-card gradient-${item.gradient}`}>
              <div className="quick-link-content">
                <div className="quick-link-icon">
                  <item.icon style={{ fontSize: 24 }} />
                </div>
                <div className="quick-link-text">
                  <h3 className="quick-link-title">{item.title}</h3>
                  <p className="quick-link-description">{item.description}</p>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </Background>
  );
};

export default QuickLinksCards;
